module.exports = __webpack_public_path__ + "static/media/logo-vn.f0a71684.png";